/**
 * @file paddle 首页的请求方法
 * @author FengGuang(fengguang01@baidu.com)
 */

import request from 'superagent';
import baseRequest from '../baseApi';


/**
 * 获取应用案列列表
 *
 * @return {Object} promise对象
 */
export const fetchGetCase = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/content/list')
            .query({contentType: 'paddleOrgUserCase'})
    );
